import Logo from '@clearkit/icons/identity/Clearbit';
import { CKBanner, CKBannerVariant, CKButton } from '@clearkit/react';

const MAINTENANCE_MODE =
  window.CB_MAINTENANCE_MODE === undefined ? false : window.CB_MAINTENANCE_MODE;

const MaintenanceMode = () => {
  if (MAINTENANCE_MODE === true) {
    return (
      <div className="fixed z-50 px-2 bottom-4 left-16 right-16">
        <CKBanner
          variant={CKBannerVariant.error}
          heading="Maintenance Mode"
          icon={<Logo />}
          timestamp={'7pm PST, Jan 21 2022'}
          description="Clearbit will be undergoing maintenance between 7pm PST and 10pm PST, Jan 21 2022."
          cta={
            <div className="flex items-center">
              <CKButton
                variant="bold"
                variantColor="red"
                href="https://status.clearbit.com/incidents/0bt5wrp5k8v8"
                as="a"
                target="_blank">
                View Details
              </CKButton>
            </div>
          }></CKBanner>
      </div>
    );
  }

  return null;
};

export default MaintenanceMode;
